import { render, staticRenderFns } from "./OrderBase.vue?vue&type=template&id=4777df05&"
import script from "./OrderBase.vue?vue&type=script&lang=ts&"
export * from "./OrderBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports